export const nifRegex = /^[a-zA-Z0-9]{8,12}$/
